"use client";
//? Library Imports ------------------------------------------------------------>
import {
  Col,
  Row,
  Form,
  Input,
  Space,
  Button,
  Select,
  message,
  Checkbox,
  Skeleton,
  Typography,
} from "antd";

import { useState, useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import PhoneInput from "react-phone-input-2";

import "./EditProfile.scss";

//? Assets --------------------------------------------------------------------->

import { ArrowLeftOutlined } from "@ant-design/icons";

//? Modules -------------------------------------------------------------------->
import AccountStatus from "@/functions/Cookies/Cookies";
import DynamicButton from "@/components/shared/Buttons/DynamicButton/DynamicButton";
//? Redux Reducers ------------------------------------------------------------->
import { updateAccountInfoReducer } from "@/redux/Slices/accountSlice";
//? Library Constants ---------------------------------------------------------->
const { Option } = Select;
const { Text } = Typography;

export default function EditProfile({ setActiveMenu }) {
  const { comverse_customer_token } = AccountStatus();
  const [countryCode, setCountryCode] = useState("pk");

  const dispatch = useDispatch();

  const [updateCustomer] = Form.useForm();

  const [Loading, setLoading] = useState(true);
  const [CustomerDetails, setCustomerDetails] = useState({});
  const [ChangePassword, setChangePassword] = useState(false);

  //? Functions ------------------------------------------------------------------>
  const fetchCustomerDetails = useCallback(async () => {
    try {
      const payload = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: comverse_customer_token,
        },
      };

      const res = await fetch(
        process.env.NEXT_PUBLIC_BACKEND + `/storefront/customer_profile`,
        payload
      );

      if (!res.ok) {
        throw new Error("Customer Profile Api Failed!");
      }

      const CustomerProfile = await res.json();
      setCustomerDetails(CustomerProfile);

      if (CustomerProfile) {
        setLoading(false);
      }

      return CustomerProfile;
    } catch (error) {
      console.error("Customer Profile Api Failed!", error);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      return null;
    }
  }, [comverse_customer_token]);

  const updateCustomerDetails = async (data) => {
    try {
      let body = {
        full_name: data.full_name,
        email: data.email,
        phone: data.phone,
        gender: data.gender,
      };
      if (!CustomerDetails?.is_sso) {
        body.current_password = data?.current_password;
      }
      if (ChangePassword && !CustomerDetails?.is_sso) {
        body.change_password = ChangePassword;
        body.new_password = data?.new_password;
        body.confirm_password = data?.confirm_password;
      }

      const payload = {
        method: "PUT",
        body: JSON.stringify(body),
        headers: {
          "Content-Type": "application/json",
          Authorization: comverse_customer_token,
        },
      };

      const updateCustomer = await fetch(
        process.env.NEXT_PUBLIC_BACKEND + `/storefront/customer_profile`,
        payload
      );

      const updateCustomerResponse = await updateCustomer.json();

      if (updateCustomer.ok) {
        dispatch(
          updateAccountInfoReducer({
            email: data?.email,
            full_name: data?.full_name,
          })
        );
        setActiveMenu("dashboard");
      }

      if (!updateCustomer.ok) {
        throw new Error(
          message.error(
            updateCustomerResponse
              ? updateCustomerResponse?.detail
              : "updateCustomer Api Failed!"
          )
        );
      } else {
        message.success("Profile Updated Successfully!");
      }

      return updateCustomerResponse;
    } catch (error) {
      console.log("updateCustomer Api Failed!", error);
    }
  };

  useEffect(() => {
    fetchCustomerDetails();
  }, [fetchCustomerDetails]);

  return (
    <Skeleton loading={Loading}>
      <Col className="EditProfile padding20">
        <Col span={24} className="padding10">
          <Space size="middle" className="flexBetween width100">
            <Space size="middle">
              <Col
                className="flexCenter cursorPointer"
                onClick={() => setActiveMenu("dashboard")}
                style={{ background: "#FFFFFF", width: "29px", height: "30px" }}
              >
                <ArrowLeftOutlined />
              </Col>
              <Text className="font18">Profile</Text>
            </Space>
            <DynamicButton
              name="Save"
              className="editBtn"
              // icon={<BiSolidPencil />}
              function={() => updateCustomer.submit()}
            />
          </Space>
        </Col>

        <Col className="marginTop15">
          <Form
            form={updateCustomer}
            name="Edit_Profile"
            layout="horizontal"
            autoComplete="on"
            scrollToFirstError
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 24 }}
            onFinish={updateCustomerDetails}
            initialValues={{
              remember: true,
              full_name: CustomerDetails?.full_name,
              email: CustomerDetails?.email,
              phone: CustomerDetails?.phone,
              gender: CustomerDetails?.gender,
            }}
          >
            <Row gutter={[20, 0]}>
              <Col flex="0 0 30%">
                <Space className="alignStart flexColumn">
                  <Text className="form-label">Full Name</Text>
                  <Form.Item
                    name="full_name"
                    rules={[
                      {
                        required: true,
                        message: "Please Enter Your Full Name",
                      },
                    ]}
                  >
                    <Input
                      style={{
                        height: "41px",
                        width: "370px",
                        borderColor: "var(--background-color)",
                      }}
                      placeholder="Full Name"
                    />
                  </Form.Item>
                </Space>
              </Col>

              <Col flex="0 0 30%">
                <Space className="alignStart flexColumn">
                  <Text className="form-label">Email</Text>
                  <Form.Item
                    name="email"
                    rules={[
                      {
                        required: true,
                        type: "email",
                        message: "Please Enter a Valid Email",
                      },
                    ]}
                  >
                    <Input
                      style={{
                        height: "41px",
                        width: "370px",
                        color: "black",
                        backgroundColor: "#ffffff",
                        borderColor: "var(--background-color)",
                      }}
                      placeholder="Email"
                      disabled
                    />
                  </Form.Item>
                </Space>
              </Col>

              <Col flex="0 0 30%">
                <Space className="alignStart flexColumn width100">
                  <Text className="form-label">Mobile Number</Text>
                  <Form.Item
                    className="width100"
                    name="phone"
                    rules={[
                      {
                        required: true,
                        message: "Please Enter a Valid Mobile Number",
                      },
                      {
                        min: 7,
                        message: "Too Short",
                      },
                      {
                        max: 20,
                        message: "Too Long",
                      },
                    ]}
                  >
                    <PhoneInput
                      disableDropdown
                      countryCodeEditable={false}
                      required
                      name="phoneNo"
                      value={CustomerDetails?.phone}
                      country={countryCode}
                      inputProps={{
                        required: true,
                        maxLength:
                          countryCode === "pk" ||
                          CustomerDetails?.country?.toLowerCase() === "pakistan"
                            ? 15
                            : 20,
                        minLength:
                          countryCode === "pk" ||
                          CustomerDetails?.country?.toLowerCase() === "pakistan"
                            ? 7
                            : 7,
                      }}
                      onChange={(value) => {
                        updateCustomer.setFieldsValue({ phone: "+" + value });
                      }}
                      style={{
                        height: "41px",
                        width: "370px",
                        borderColor: "var(--background-color)",
                      }}
                    />
                  </Form.Item>
                </Space>
              </Col>

              <Col flex="0 0 30%">
                <Space className="alignStart flexColumn">
                  <Text className="form-label">Gender</Text>
                  <Form.Item
                    name="gender"
                    rules={[
                      {
                        required: true,
                        message: "Select your Gender",
                      },
                    ]}
                  >
                    <Select
                      value={CustomerDetails?.gender}
                      style={{
                        height: "auto",
                        width: "370px",
                      }}
                      className="select-style"
                    >
                      <Option value="male">Male</Option>
                      <Option value="female">Female</Option>
                      <Option value="other">Other</Option>
                    </Select>
                  </Form.Item>
                </Space>
              </Col>

              {!CustomerDetails?.is_sso && (
                <Col flex="0 0 30%">
                  <Space className="alignStart flexColumn">
                    <Text className="form-label">Password</Text>
                    <Form.Item
                      name="current_password"
                      rules={[
                        {
                          required: true,
                          message: "Please Enter Your Password",
                        },
                        {
                          min: 3,
                          message: "Too Short",
                        },
                      ]}
                    >
                      <Input.Password
                        style={{
                          height: "41px",
                          width: "370px",
                          borderColor: "var(--background-color)",
                        }}
                        placeholder="**********"
                      />
                    </Form.Item>
                  </Space>
                </Col>
              )}

              {!CustomerDetails?.is_sso && (
                <Col flex="0 0 30%" className="alignCenter">
                  <Space className="alignStart flexColumn">
                    <Checkbox
                      name="change_password"
                      onChange={() => setChangePassword(!ChangePassword)}
                    >
                      Change Password
                    </Checkbox>
                  </Space>
                </Col>
              )}

              {ChangePassword && !CustomerDetails?.is_sso ? (
                <Row gutter={[20, 0]}>
                  <Col flex="0 0 30%">
                    <Space className="alignStart flexColumn">
                      <Text className="form-label">New Password</Text>
                      <Form.Item
                        name="new_password"
                        rules={[
                          {
                            required: true,
                            message: "Please Enter Your Password",
                          },
                          {
                            min: 3,
                            message: "Too Short",
                          },
                        ]}
                      >
                        <Input.Password
                          style={{
                            height: "41px",
                            width: "370px",
                            borderColor: "var(--background-color)",
                          }}
                          placeholder="**********"
                        />
                      </Form.Item>
                    </Space>
                  </Col>

                  <Col flex="0 0 30%">
                    <Space className="alignStart flexColumn">
                      <Text className="form-label">Confirm Password</Text>
                      <Form.Item
                        name="confirm_password"
                        rules={[
                          {
                            required: true,
                            message: "Kindly Confirm Your Password",
                          },
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              if (
                                !value ||
                                getFieldValue("new_password") === value
                              ) {
                                return Promise.resolve();
                              }
                              return Promise.reject(
                                new Error(
                                  "The new password that you entered do not match!"
                                )
                              );
                            },
                          }),
                        ]}
                      >
                        <Input.Password
                          style={{
                            height: "41px",
                            width: "370px",
                            borderColor: "var(--background-color)",
                          }}
                          placeholder="**********"
                        />
                      </Form.Item>
                    </Space>
                  </Col>
                </Row>
              ) : null}
            </Row>
          </Form>
        </Col>
      </Col>
    </Skeleton>
  );
}
